"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAwsAuthPlugin = exports.awsAuthMiddlewareOptions = exports.awsAuthMiddleware = void 0;

var tslib_1 = require("tslib");

var protocol_http_1 = require("@aws-sdk/protocol-http");

var isClockSkewed = function isClockSkewed(newServerTime, systemClockOffset) {
  return Math.abs(getSkewCorrectedDate(systemClockOffset).getTime() - newServerTime) >= 300000;
};

var getSkewCorrectedDate = function getSkewCorrectedDate(systemClockOffset) {
  return new Date(Date.now() + systemClockOffset);
};

function awsAuthMiddleware(options) {
  return function (next) {
    return function (args) {
      return tslib_1.__awaiter(this, void 0, void 0, function () {
        var signer, _a, output, _b, _c, _d, headers, dateHeader, serverTime;

        return tslib_1.__generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              if (!protocol_http_1.HttpRequest.isInstance(args.request)) return [2
              /*return*/
              , next(args)];
              if (!(typeof options.signer === "function")) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , options.signer()];

            case 1:
              _a = _e.sent();
              return [3
              /*break*/
              , 3];

            case 2:
              _a = options.signer;
              _e.label = 3;

            case 3:
              signer = _a;
              _b = next;
              _c = [tslib_1.__assign({}, args)];
              _d = {};
              return [4
              /*yield*/
              , signer.sign(args.request, {
                signingDate: new Date(Date.now() + options.systemClockOffset)
              })];

            case 4:
              return [4
              /*yield*/
              , _b.apply(void 0, [tslib_1.__assign.apply(void 0, _c.concat([(_d.request = _e.sent(), _d)]))])];

            case 5:
              output = _e.sent();
              headers = output.response.headers;
              dateHeader = headers && (headers.date || headers.Date);

              if (dateHeader) {
                serverTime = Date.parse(dateHeader);

                if (isClockSkewed(serverTime, options.systemClockOffset)) {
                  options.systemClockOffset = serverTime - Date.now();
                }
              }

              return [2
              /*return*/
              , output];
          }
        });
      });
    };
  };
}

exports.awsAuthMiddleware = awsAuthMiddleware;
exports.awsAuthMiddlewareOptions = {
  name: "awsAuthMiddleware",
  step: "finalizeRequest",
  tags: ["SIGNATURE", "AWSAUTH"],
  relation: "after",
  toMiddleware: "retryMiddleware"
};

exports.getAwsAuthPlugin = function (options) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.addRelativeTo(awsAuthMiddleware(options), exports.awsAuthMiddlewareOptions);
    }
  };
};